import { FormikValues, useFormikContext } from 'formik';
import React from 'react';

interface Props {
    children: React.ReactElement | React.ReactElement[] | string;
    tema?: 'primary' | 'secondary' | 'light' | 'dark' | 'success' | 'danger' | 'warning' | 'info';
    type?: 'submit' | 'reset' | 'button';
}

const Botao = ({ children, tema = 'primary', type = 'submit' }: Props): React.ReactElement =>
{
    const { isSubmitting, } = useFormikContext<FormikValues>();

    return (
        <button
            type={ type }
            className={ `btn btn-${tema}` }
            disabled={ isSubmitting }
        >
            { isSubmitting && type === 'submit' ? (
                <React.Fragment>
                    <span className="spinner-grow spinner-grow-sm me-2" role="status"></span>
                    Aguarde...
                </React.Fragment>
            ) : (
                <span>
                    { children }
                </span>
            ) }
        </button>
    );
}

export default Botao;
